import originalStore from '../../app/store';
import { offline } from '../../arguments';
import { setUser } from '../../features/auth/actions/auth.actions';
import { checkStatus } from '../../features/auth/clients/auth.client';
import { userSelector } from '../../features/auth/selectors/auth.selectors';

const defaultOptions: RequestInit = {
  // anything you want to share with requests (auth, cors config, cache, etc.)
  headers: {
    'Content-Type': 'application/json',
  },
};

async function handleStatus(response: any, store: typeof originalStore) {
  switch (response.status) {
    case 401:
      store.dispatch(setUser({ user: null, meta: { history: false } }));
      throw new Error('Not authorized');
    case 400:
      throw new Error('Bad request');
    case 403: {
      const user = await checkStatus();
      const currentUser = userSelector(store.getState());
      if (user == null || currentUser?.id !== user.id) {
        store.dispatch(setUser({ user: null, meta: { history: false } }));
      }
      throw new Error('Forbidden');
    }
    default:
      return response;
  }
}

function handleErrors(error: any): never {
  throw error;
}

export default async function fetchWithOptions<T = any>(
  url: string,
  options?: RequestInit,
  store = originalStore,
): Promise<T> {
  try {
    if (offline) {
      try {
        return await loadResponse(url);
      } catch {} /* eslint-disable-line no-empty */
    }
    const response = await fetch(url, { ...defaultOptions, ...options });
    const resp = await handleStatus(response, store);

    const json = await resp.json();

    if (offline) {
      saveResponse(json, url, options);
    }
    return json;
  } catch (error) {
    return handleErrors(error);
  }
}

const saveResponse = (json: any, url: string, options: RequestInit = {}) => {
  if (options.method == null || options.method === 'GET') {
    localStorage.setItem(url, JSON.stringify(json));
  }
};

const loadResponse = (url: string) => {
  const value = localStorage.getItem(url);
  if (value == null) {
    throw Error(`no value for url: ${url}`);
  }
  return Promise.resolve(JSON.parse(value));
};
